import {
    DatePicker,
    Form,
    Modal,
    Row,
    Col,
    Button,
    message,
    Upload,
    Radio,
    Tooltip,
    Table,
    Select,
    TimePicker
} from "antd";
import {UploadOutlined, DeleteOutlined} from "@ant-design/icons";
import {useFormik} from "formik";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {useStore} from "../../../../hooks/useStore";
import config from "../../../../_core/config";
import {b64DecodeToUrl} from "../../../../utils/helpers";
import {useEffect} from "react";
import localeTr from "antd/es/date-picker/locale/tr_TR";
import localeEn from "antd/es/date-picker/locale/en_US";

const ShiftForecastUploadModal = ({visibility, onCancel, setReloadData, setModalVisible}) => {
    const {t, i18n} = useTranslation();

    const stores = useStore();
    const [confirmLoading, setConfirmLoading] = useState();
    const [importLoading, setImportLoading] = useState();
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [template, setTemplate] = useState("default");
    const [seniorityData, setSeniorityData] = useState([]);
    const [showSeniorityTable, setShowSeniorityTable] = useState(false);
    const [open, setOpen] = useState(false);

    const [openingTime, setOpeningTime] = useState(
        moment().set({minute: moment().minute(), second: 0, millisecond: 0})
    );
    const [lastPreferenceTime, setLastPreferenceTime] = useState(moment().add(2, "hours"));

    useEffect(() => {
        setOpeningTime(moment().set({minute: moment().minute(), second: 0, millisecond: 0}));
        setLastPreferenceTime(
            moment()
                .set({minute: moment().minute(), second: 0, millisecond: 0})
                .add(2, "hours")
        );
        setFileList([]);
    }, [visibility]);

    const formik = useFormik({
        initialValues: {date: undefined},
        validationSchema: yup.object().shape({
            date: yup.string().required(t("validation.required", {ns: "common"})),
            option: yup.string()
        }),
        enableReinitialize: true,
        onSubmit: () => {}
    });

    const {values, errors, touched, setFieldValue} = formik;
    useEffect(() => {
        setFieldValue("date", moment().add(1, "days"));
    }, []);
    const getDisabledDate = current => {
        let customDate = moment().format("DD.MM.YYYY");
        return current && current < moment(customDate, "DD.MM.YYYY");
    };

    const handleUpload = ({convertToShift = false}) => {
        formik.handleSubmit();
        const formData = new FormData();
        formData.append("rules", JSON.stringify({rules: formatSeniorityData()}));
        formData.append("lastPreferenceTime", JSON.stringify(lastPreferenceTime.format("HH:mm")));
        fileList.forEach(file => {
            formData.append("files[]", file);
        });
        props.action = convertToShift ? props.convertAction : props.action;
        props.action += moment(values.date).format("YYYY-MM-DD");
        props.action += "/" + template;
        setUploading(true);
        setImportLoading(true);
        fetch(props.action, {
            method: "POST",
            headers: {Authorization: "Basic " + stores.meStore.sessionToken},
            body: formData
        })
            .then(res => res.json())
            .then(async res => {
                if (res.result.isSuccess == false) {
                    message.error(
                        t("companyDetail.modal.fileUpload.error", {
                            ns: "companyDetail",
                            filename: fileList[0].name,
                            responseMessage: res.result.message
                        })
                    );
                    return;
                } else {
                    setFileList([]);
                    message.success("upload successfully.");
                    const responseMessages = [];
                    const validationMessages = res.result.validationMessages;
                    let errorExcel = res.result.errorExcel;
                    if (errorExcel) {
                        responseMessages.push(
                            <div key={"error"}>
                                <b>
                                    {t("companyDetail.modal.fileUpload.errorExcel", {
                                        ns: "companyDetail"
                                    })}
                                </b>
                            </div>
                        );
                        errorExcel = await b64DecodeToUrl(errorExcel);
                        let link = document.createElement("a");
                        link.href = errorExcel;
                        link.download = `${t("screens.shiftSuggestion", {ns: "common"})}.xlsx`;
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(function() {
                            window.URL.revokeObjectURL(link);
                        }, 200);
                    }

                    let convertedShiftExcel = res.result.convertedShiftExcel;
                    if (convertedShiftExcel) {
                        convertedShiftExcel = await b64DecodeToUrl(convertedShiftExcel);
                        let link = document.createElement("a");
                        link.href = convertedShiftExcel;
                        link.download = `${t("convertedCourierPlan", {
                            ns: "shiftSuggestion"
                        })}.xlsx`;
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(function() {
                            window.URL.revokeObjectURL(link);
                        }, 200);
                    }
                    for (const message of validationMessages) {
                        responseMessages.push(<div key={message}>{message}</div>);
                    }
                    stores.appStore.openSuccessModal({
                        title: t("companyDetail.modal.fileUpload.success", {ns: "companyDetail"}),
                        content: responseMessages
                    });
                    setReloadData();
                }
            })
            .catch(error => {
                console.log(error);
                message.error("upload failed.");
            })
            .finally(() => {
                setUploading(false);
                setImportLoading(false);
                setModalVisible(false);
                setFieldValue("date", moment().add(1, "days"));
            });
    };

    const props = {
        multiple: false,
        action: `${config.getBasePublicUrl()}api/panel/v1/shifts/suggestion/import-forecast/`,
        convertAction: `${config.getBasePublicUrl()}api/panel/v1/shifts/forecast-converter/`,
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: file => {
            setFileList([...fileList, file]);
            return false;
        },
        fileList
    };
    const onChangeTemplate = e => {
        setTemplate(e.target.value);
    };

    const renderFooter = () => {
        const active = (
            <Button
                key="handleUpload"
                type="primary"
                danger
                disabled={fileList.length === 0}
                loading={uploading}
                onClick={handleUpload}
            >
                {t("modal.sendButton", {ns: "common"})}
            </Button>
        );

        const cancel = (
            <Button
                key="cancel"
                disabled={confirmLoading}
                loading={uploading}
                onClick={() => {
                    setOpen(false);
                    onCancel(false);
                    setFieldValue("date", moment().add(1, "days"));
                }}
            >
                {t("modal.cancelButton2", {ns: "common"})}
            </Button>
        );

        const convert = (
            <Button
                key="convert"
                type="primary"
                disabled={fileList.length === 0}
                loading={uploading}
                onClick={() => handleUpload({convertToShift: true})}
            >
                <Tooltip title={t("convertToShift", {ns: "shiftSuggestion"})}>
                    {t("actions.convert", {ns: "common"})}
                </Tooltip>
            </Button>
        );

        return [cancel, active, convert];
    };
    const openingTimeDisabledHours = () => {
        let hours = [];
        let minutes = [];
        if (moment().hour() === openingTime.hour()) {
            for (let i = 0; i <= openingTime.minute(); i++) {
                minutes.push(i);
            }
        }
        for (let i = 0; i < openingTime.hour(); i++) {
            if (minutes.includes(45)) {
                hours.push(i + 1);
            }
            hours.push(i);
        }
        return hours;
    };

    const openingTimeDisabledMinutes = () => {
        let minutes = [];
        if (moment().hour() === openingTime.hour()) {
            for (let i = 0; i <= moment().minute(); i++) {
                minutes.push(i);
            }
        }

        return minutes;
    };

    const selectOptions = [
        {value: 24, label: "+24"},
        {value: 12, label: "+12"},
        {value: 9, label: "+9"},
        {value: 6, label: "+6"},
        {value: 3, label: "+3"},
        {value: 0, label: "0"}
    ];

    const filteredSelectOptions = selectOptions.filter(
        item => !seniorityData.map(item => item.seniority).includes(item.label)
    );

    useEffect(() => {
        setSeniorityData([
            {
                key: "12",
                seniority: "+12",
                time: moment(openingTime),
                button: (
                    <DeleteOutlined
                        onClick={() =>
                            setSeniorityData(prev => prev.filter(item => item.key !== "12"))
                        }
                    />
                )
            },
            {
                key: "6",
                seniority: "+6",
                time: moment(openingTime).add(0.5, "hours"),
                button: (
                    <DeleteOutlined
                        onClick={() =>
                            setSeniorityData(prev => prev.filter(item => item.key !== "6"))
                        }
                    />
                )
            },
            {
                key: "0",
                seniority: "0",
                time: moment(openingTime).add(1, "hours"),
                button: (
                    <DeleteOutlined
                        onClick={() =>
                            setSeniorityData(prev => prev.filter(item => item.key !== "0"))
                        }
                    />
                )
            }
        ]);
    }, [showSeniorityTable, visibility]);

    const handleSelectChange = (data, oldKey) => {
        setSeniorityData(prev => {
            const biggerThanDataIndex = prev
                .sort((a, b) => a.key - b.key)
                .findIndex(item => item.key > data);

            const currentTime = moment(prev[biggerThanDataIndex]?.time);
            const newArray = [
                ...prev,
                {
                    key: data.toString(),
                    seniority: data === 0 ? "0" : "+" + data,
                    time:
                        biggerThanDataIndex === -1
                            ? moment(openingTime)
                            : currentTime.add(0.5, "hours")
                }
            ]
                .filter(item => item.key !== "new")
                .filter(item => item.key !== oldKey)
                .sort((a, b) => b.key - a.key);

            return [...newArray];
        });
        calibrateSeniorityTable();
    };

    const handleSelectTime = (date, key) => {
        setSeniorityData(prev => {
            const index = prev.find(item => item.key === key.key);
            index.time = moment(date);

            return [...prev];
        });
    };
    const handleChangeLastPreferenceTime = lastPreferenceDate => {
        const sortedSeniortyRules = JSON.parse(
            JSON.stringify(seniorityData.sort((a, b) => a.key - b.key))
        );
        const latestRule =
            sortedSeniortyRules.length > 0 ? sortedSeniortyRules[0].time : openingTime;
        if (
            moment(latestRule)
                .add(1, "hours")
                .isBefore(lastPreferenceDate)
        ) {
            setLastPreferenceTime(lastPreferenceDate);
        } else {
            setLastPreferenceTime(moment(latestRule).add(1, "hours"));
        }
    };

    const lastPreferenceTimeDisabledHours = () => {
        const sortedSeniortyRules = JSON.parse(
            JSON.stringify(seniorityData.sort((a, b) => a.key - b.key))
        );
        const latestRule =
            sortedSeniortyRules.length > 0 ? sortedSeniortyRules[0].time : openingTime;
        let hours = [];
        let minutes = [];
        if (moment().hour() === moment(latestRule).hour()) {
            for (let i = 0; i <= latestRule.minute(); i++) {
                minutes.push(i);
            }
        }
        for (let i = 0; i < moment(latestRule).hour(); i++) {
            if (minutes.includes(45)) {
                hours.push(i + 1);
            }
            hours.push(i);
        }
        return hours;
    };

    const lastPreferenceTimeDisabledMinutes = () => {
        const sortedSeniortyRules = JSON.parse(
            JSON.stringify(seniorityData.sort((a, b) => a.key - b.key))
        );
        const latestRule =
            sortedSeniortyRules.length > 0 ? sortedSeniortyRules[0].time : openingTime;
        let minutes = [];
        if (moment().hour() === moment(latestRule).hour()) {
            for (let i = 0; i <= moment().minute(); i++) {
                minutes.push(i);
            }
        }

        return minutes;
    };

    const calibrateSeniorityTable = () => {
        setSeniorityData(prev => {
            return [...prev].map((item, index) => {
                if (index === 0) {
                    return {...item, time: moment(openingTime)};
                }
                return {...item, time: moment(openingTime).add(index * 0.5, "hours")};
            });
        });
    };

    const deleteSeniority = key => {
        setSeniorityData(prev => prev.filter(item => item.key !== key));
        calibrateSeniorityTable();
    };

    const formatSeniorityData = () => {
        const rules = [];
        seniorityData.forEach(item => {
            rules.push({
                month: item?.key,
                hour: item?.time?.format("HH:mm")
            });
        });
        if (rules.length === 0) {
            rules.push({
                month: "0",
                hour: openingTime.format("HH:mm")
            });
        }
        return rules;
    };

    const handleTimePickerSelect = date => {
        const minutes = moment(date).format("mm");
        const hoursMatch = moment(openingTime).format("HH") === moment(date).format("HH");
        setOpeningTime(date);

        if (["00", "15", "30", "45"].includes(minutes) && hoursMatch) {
            setOpen(false);
            calibrateSeniorityTable();
            setShowSeniorityTable(true);
        }
    };

    return (
        <Modal
            title={"Kurye Planı Yükle"}
            visible={visibility}
            onCancel={() => {
                setOpen(false);
                onCancel(false);
                setFieldValue("date", moment().add(1, "days"));
            }}
            okButtonProps={{disabled: fileList.length === 0}}
            onOk={handleUpload}
            loading={uploading}
            confirmLoading={confirmLoading}
            footer={renderFooter()}
        >
            <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Row>
                    <Col span={24}>
                        <Row
                            style={{
                                justifyContent: "space-between"
                            }}
                        >
                            <Form.Item
                                label={t("fields.date", {ns: "common"})}
                                validateStatus={errors.date && touched.date ? "error" : "success"}
                                help={errors.date && touched.date ? errors.date : null}
                            >
                                <DatePicker
                                    value={values.date}
                                    format={"DD.MM.YYYY"}
                                    disabledDate={getDisabledDate}
                                    onSelect={date => setFieldValue("date", date)}
                                />
                            </Form.Item>

                            <Form.Item
                                style={{
                                    marginRight: 40
                                }}
                                label={t("fields.hour", {ns: "common"})}
                                validateStatus={errors.date && touched.date ? "error" : "success"}
                                help={errors.date && touched.date ? errors.date : null}
                            >
                                <TimePicker
                                    defaultValue={moment().set({
                                        minute: moment().minute(),
                                        second: 0,
                                        millisecond: 0
                                    })}
                                    showNow={false}
                                    popupClassName="shift-suggestion-modal-time-picker"
                                    format={"HH:mm"}
                                    allowClear={false}
                                    minuteStep={15}
                                    onOk={() => setOpen(false)}
                                    value={openingTime}
                                    open={open}
                                    onOpenChange={date => {
                                        if (date) {
                                            setOpen(true);
                                        }
                                    }}
                                    changeOnBlur={true}
                                    onSelect={date => handleTimePickerSelect(date)}
                                    locale={i18n?.resolvedLanguage === "en" ? localeEn : localeTr}
                                    disabledHours={openingTimeDisabledHours}
                                    disabledMinutes={openingTimeDisabledMinutes}
                                />
                            </Form.Item>
                        </Row>
                        {
                            <Form.Item
                                label={t("seniorityRules", {ns: "shiftSuggestion"})}
                                validateStatus={errors.date && touched.date ? "error" : "success"}
                                help={errors.date && touched.date ? errors.date : null}
                            >
                                <Table
                                    dataSource={seniorityData.sort(
                                        (a, b) => b.seniority - a.seniority
                                    )}
                                    size="small"
                                    rowKey={record => record.key}
                                    pagination={false}
                                >
                                    <Table.Column
                                        title={t("seniority", {ns: "shiftSuggestion"})}
                                        dataIndex="seniority"
                                        render={(seniority, key) => (
                                            <Select
                                                defaultValue={seniority}
                                                style={{width: 80, borderWidth: "0px"}}
                                                onSelect={data =>
                                                    handleSelectChange(data, key.key, seniority)
                                                }
                                                options={filteredSelectOptions}
                                            />
                                        )}
                                    />
                                    <Table.Column
                                        title={t("fields.hour", {ns: "common"})}
                                        style={{
                                            backgroundColor: "red"
                                        }}
                                        dataIndex="time"
                                        render={(time, key) => (
                                            <TimePicker
                                                popupClassName="shift-suggestion-modal-time-picker"
                                                defaultValue={time}
                                                format={"HH:mm"}
                                                allowClear={false}
                                                minuteStep={15}
                                                value={time}
                                                onSelect={date => handleSelectTime(date, key, time)}
                                                locale={
                                                    i18n?.resolvedLanguage === "en"
                                                        ? localeEn
                                                        : localeTr
                                                }
                                                disabledHours={date =>
                                                    openingTimeDisabledHours(date, key, time)
                                                }
                                            />
                                        )}
                                    />
                                    <Table.Column
                                        title={t("removeSelection", {ns: "shiftSuggestion"})}
                                        dataIndex="button"
                                        render={(button, key) => (
                                            <DeleteOutlined
                                                onClick={() => deleteSeniority(key.key)}
                                            />
                                        )}
                                    />
                                </Table>
                                <Col
                                    style={{
                                        marginTop: "20px"
                                    }}
                                    align="center"
                                >
                                    {seniorityData.length < 6 && (
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                setSeniorityData([
                                                    ...seniorityData,
                                                    {
                                                        key: "new",
                                                        seniority: "",
                                                        time: moment(openingTime)
                                                    }
                                                ])
                                            }
                                        >
                                            {t("newRule", {ns: "shiftSuggestion"})}
                                        </Button>
                                    )}
                                </Col>
                            </Form.Item>
                        }
                        <Form.Item label={t("lastPreferenceTime", {ns: "shiftSuggestion"})}>
                            <TimePicker
                                popupClassName="shift-suggestion-modal-last-preference-time-picker"
                                format={"HH:mm"}
                                allowClear={false}
                                minuteStep={15}
                                value={lastPreferenceTime}
                                onSelect={lastPreferenceDate =>
                                    handleChangeLastPreferenceTime(lastPreferenceDate)
                                }
                                locale={i18n?.resolvedLanguage === "en" ? localeEn : localeTr}
                                // disabledHours={lastPreferenceTimeDisabledHours}
                                // disabledMinutes={lastPreferenceTimeDisabledMinutes}
                            />
                        </Form.Item>
                        <Form.Item label={t("template", {ns: "shiftSuggestion"})}>
                            <Radio.Group onChange={onChangeTemplate} defaultValue="default">
                                <Radio.Button value="default">Vigo</Radio.Button>
                                <Radio.Button value="vigoPlus">Vigo+</Radio.Button>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label={t("fields.file", {ns: "common"})}
                            validateStatus={errors.date && touched.date ? "error" : "success"}
                            help={errors.date && touched.date ? errors.date : null}
                        >
                            <Upload {...props} accept=".xlsx,.xls,.csv,.tsv">
                                <Button icon={<UploadOutlined />}>
                                    {t("fields.selectFile", {ns: "common"})}
                                </Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ShiftForecastUploadModal;
